import { handleMessages, load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('change', '[data-ccm-configurator-form]', function(event) {
  const $form = $(this);
  const input = event.target;

  if (input.name === 'step') {
    document.querySelectorAll('.ccm_configuration__tabs-nav-item').forEach((el) => {
      $(el).removeClass('is-active');
    });
    const tab = document.querySelector(`label[for=${input.id}]`);
    $(tab).addClass('is-active');
  } else if (['assortment', 'cable_type', 'category'].includes(input.name)) {
    if (input.name === 'cable_type') {
      $form.find('select[name="category"]').val(null);
    }
    $form.find('select[name="fiber_count"]').val(null).prop('disabled', true);
    if (
      ($form.find('select[name="assortment"]').val() && $form.find('select[name="cable_type"]').val()) ||
      ($form.find('select[name="assortment"]').val() && $form.find('select[name="category"]').val())
    ) {
      $form.submit();
    }
  } else if (input.name === 'cable_nr') {
    $form.find('select[name="fiber_count"]').val(null).prop('disabled', true);
    $form.find('select[name="whip_length_a"]').val(null);
    $form.find('select[name="whip_length_b"]').val(null);
    $form.find('select[name="plug_a"]').val(null);
    $form.find('select[name="plug_b"]').val(null);
    $form.submit();
  } else if (input.name === 'fiber_count') {
    $form.find('select[name="whip_length_a"]').val(null);
    $form.find('select[name="whip_length_b"]').val(null);
    $form.find('select[name="plug_a"]').val(null);
    $form.find('select[name="plug_b"]').val(null);
    $form.submit();
  } else if (input.name === 'label_a' && !$form.find('input[name="label_b"]').val()) {
    $form.find('input[name="label_b"]').val(input.value);
  } else if (['label_a', 'label_b', 'length', 'quantity'].includes(input.name)) {
    //
  } else {
    $form.submit();
  }
});

$(document).on('submit', '[data-ccm-configurator-form]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const $content = $form.closest('[data-ccm-configurator]');

  const data = $form.serializeArray();
  // const data = $form.serializeArray().filter(val => val.value);

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data,
  }).then(handleMessages).then((resp) => {
    $content.replaceWith(resp.html);
  });

  load($content, promise, {
    errorClass: 'error',
  });
});

$(document).on('click', '[data-ccm-configurator-cart]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('[data-ccm-configurator-form]');
  const $content = $form.closest('[data-ccm-configurator]');

  const promise = $.ajax({
    url: $(this).attr('data-ccm-configurator-cart'),
    method: 'POST',
    data: $form.serialize(),
  }).then(handleMessages).then((data) => {
    if (data.redirect) {
      window.location.href = data.redirect;
    } else {
      $.stores.cart.update(data);
      $content.replaceWith(data.html);
    }
  });

  load($content, promise, {
    errorClass: 'error',
  });
});

$(document).on('click', '[data-ccm-configurator-label]', function() {
  $(`label[for="${$(this).attr('data-ccm-configurator-label')}"]`).click();
});
